module.exports = __webpack_public_path__ + "img/mind_skeleton_time_8.d0f68a14.png";